import { render, staticRenderFns } from "./adItem.vue?vue&type=template&id=826cb244&scoped=true"
import script from "./adItem.vue?vue&type=script&lang=js"
export * from "./adItem.vue?vue&type=script&lang=js"
import style0 from "./adItem.vue?vue&type=style&index=0&id=826cb244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826cb244",
  null
  
)

export default component.exports